import React, { useState, useEffect } from 'react';
import axios from './axios';
import "./Row1.css";
import Youtube from 'react-youtube';
import movieTrailer from 'movie-trailer';


function Row({ title, fetchUrl, isLargeRow}) {
    
    const [movies, setMovies] = useState([]);
    const [trailerUrl, setTrailerUrl] = useState("");
    const based_url =  "https://image.tmdb.org/t/p/original/";
    
    // A snippet
    useEffect(()=>{
        // if [], run onche when the row loads, and dont run again
        async function fetchData(){
            const request = await axios.get(fetchUrl);
            setMovies(request.data.results);
            return request;
        }

        fetchData();

    },[fetchUrl]);

    const opts = {
        heigth:"390",
        width:"100%",
        playerVars:{
            autoplay:1,
        },
    };
      
    const handleClick = (item) =>{
        if(trailerUrl){
            setTrailerUrl("");
        }else{
            movieTrailer(item?.name || "")
            .then((url) =>{
                const urlParams = new URLSearchParams(new URL(url).search);
                setTrailerUrl(urlParams.get('v'));
            })
            .catch((error) => console.log(error));
        }
    }

    return (
        <div className="row">
            <h2>{title}</h2>
            <div className="row__posters">
                {movies.map( item=>(
                    <img 
                    key={item.id}
                    onClick={()=>handleClick(item)}
                    className={`row__poster ${isLargeRow && "row__posterLarge"}`}
                    src={`${based_url}${isLargeRow ? item.poster_path : item.backdrop_path}`} 
                    alt={item.name}/>
                ))}
            </div>
            {/* Container */}
            {trailerUrl && <Youtube videoId={trailerUrl} opts={opts}/>}
        </div>
    )
}

export default Row
